import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import ChooseLineToActivate from '../Partials/Cellular/ChooseLineToActivate/ChooseLineToActivate';
import { goToPage, reportDWH , setSelectedEsimLine} from '../saleJetBlockSlice';
import { goToEsimQrCodePageAsync } from '../saleBlockAsyncThunk';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';

const CellularChooseLineToActivatePage = (props) => {
  const [selectedLine , setSelectedLine] = useState("");
  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let totalPrice = null;
  let priceText = '';
  let currentPageFunction = handlePageContinue;
  let formid = 'saleJet';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'> התחדשתם ב-eSIM! עם איזה מספר תרצו שנתחיל? </h1>
      <h2 className='sale-title-small'></h2>
    </div>
  );

  let currentPageView = (
    <ChooseLineToActivate cellularSettingsList={props.cellularSettingsList} onSelectedLine={handleOnSelectedLine} selectedLine={selectedLine} instructions={props.esimData?.chooseSubscriberPageTextList?.value} />
  );


  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handleOnSelectedLine(item) {
    setSelectedLine(item);
    props.setSelectedEsimLine(item);
  }

  function handlePageContinue() {
    if(selectedLine.phoneType === "new"){
      props.goToEsimQrCodePageAsync({ selectedLine });
    }
    else{
      buildUrlAndOpenWindow(props.urlNiudEsimPage);
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    cellularSettingsList : state.saleJetBlock.cellular.cellularSettingsList,
    urlNiudEsimPage: state.saleJetBlock.saleBlockData.urlNiudEsimPage,
    resultByOrders: state.saleJetBlock.resultByOrders,
    esimData : state.saleJetBlock.saleBlockData.esimData,

    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  reportDWH,
  setSelectedEsimLine,
  goToEsimQrCodePageAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(CellularChooseLineToActivatePage);
